module.exports = __webpack_public_path__ + "img/afhaal01-2022.b7b93b4a.png";